import ReportDetailsPage from './ReportDetailsPage.component';

export default ReportDetailsPage;
